import { render, staticRenderFns } from "./edit-region.vue?vue&type=template&id=582ece60&scoped=true&"
import script from "./edit-region.vue?vue&type=script&lang=ts&"
export * from "./edit-region.vue?vue&type=script&lang=ts&"
import style0 from "./edit-region.vue?vue&type=style&index=0&id=582ece60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582ece60",
  null
  
)

component.options.__file = "edit-region.vue"
export default component.exports